'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

angular.module('app').directive('timeline', function ($window, $filter, $translate, Timeline) {
  return {
    restrict: 'E',
    scope: {
      meta: '=',
      step: '='
    },
    replace: true,
    template: '<div class="timeline"><svg class="timeline__chart"></svg></div>',
    link: function link(scope, element) {
      return new (function () {
        function _class() {
          var _this = this;

          _classCallCheck(this, _class);

          // Get i18n filter function
          this.i18n = $filter('i18n');
          // Resize the parent element to fit to the screen
          this.fit();
          // Create a SVG and append it to the element
          this.svg = d3.select(element[0]).select('svg');
          // Create a Timeline instance
          this.timeline = new Timeline(this.svg);
          // Use dynamic sizes
          this.timeline.config(this.bounding());
          // Watch for change on the step attribute
          scope.$watch('step', function (step) {
            // Don't go too far!
            if (step < scope.meta.length) {
              // Draw the timeline at a given step
              _this.draw(step);
            }
          });
          // Watch for windows resize
          angular.element($window).on(this.windowResizeEvent, _.throttle(this.resize.bind(this), 150));
          // Watch for scope destruction
          scope.$on('$destroy', function () {
            return angular.element($window).off(_this.windowResizeEvent);
          });
        }

        _createClass(_class, [{
          key: 'bounding',
          value: function bounding() {
            // Get SVG sizes
            return _.pick(this.svg.node().getBoundingClientRect(), ['width', 'height']);
          }
          // Get last available data for the given step

        }, {
          key: 'data',
          value: function data(step) {
            return step >= 0 ? scope.meta[step].data || this.data(step - 1) : [];
          }
        }, {
          key: 'smoothing',
          value: function smoothing(step) {
            return (scope.meta[step] || {}).smoothing || 0;
          }
        }, {
          key: 'draw',
          value: function draw(step) {
            this.timeline.config({
              yunit: this.i18n(scope.meta[step].yaxislabel),
              highlights: this.i18n(scope.meta[step].highlights),
              smoothing: this.smoothing(step),
              rulers: [[2004, $translate.instant('timeline.rulers.10-new-country')], [2007, $translate.instant('timeline.rulers.romania-bulgaria')], [2013, $translate.instant('timeline.rulers.croatia')]],
              type: scope.meta[step].charttype,
              min: scope.meta[step].min,
              max: scope.meta[step].max
            });
            // Configure the chart with the new step
            this.timeline.draw(this.data(step));
          }
        }, {
          key: 'resize',
          value: function resize() {
            // Parent element must fit to the new window's height
            this.fit();
            // Use dynamic sizes
            this.timeline.config(this.bounding());
            // And redraw at the current step
            this.draw(scope.step);
          }
        }, {
          key: 'fit',
          value: function fit() {
            angular.element(element).css('height', angular.element(window).height() - angular.element(element).offset().top);
          }
          // Uniq event on window element to destroy it with the directive

        }, {
          key: 'windowResizeEvent',
          get: function get() {
            // Create the event tken only once
            this._windowResizeEvent = this._windowResizeEvent || _.uniqueId() + ' resize';
            // Simply return the event string
            return this._windowResizeEvent;
          }
        }]);

        return _class;
      }())();
    }
  };
});